export const whitespace = `
_ "whitespace"
  = SPACE*

SPACE "space"
  = [ \\t\\n\\r]+
`;
//# sourceMappingURL=whitespace.js.map